var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "c--input_dropdown dropdown-wrapper position-relative"
  }, [_c('div', {
    staticClass: "dropdown-wrapper-selected"
  }, [_c('label', {
    attrs: {
      "for": _vm.elementId
    }
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.selectedModel,
      expression: "selectedModel"
    }],
    ref: `${_vm.elementId}Ref`,
    class: `dir-${_vm.direction}`,
    attrs: {
      "name": `${_vm.elementId}Name`,
      "id": _vm.elementId
    },
    on: {
      "change": [function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.selectedModel = $event.target.multiple ? $$selectedVal : $$selectedVal[0];
      }, function ($event) {
        $event.preventDefault();
        return _vm.onChange.apply(null, arguments);
      }]
    }
  }, _vm._l(_vm.options, function (option, index) {
    return _c('option', {
      key: `${_vm.elementId}-option-${index}`,
      domProps: {
        "value": option.value
      }
    }, [_vm._v("\n        " + _vm._s(option.text) + "\n      ")]);
  }), 0)])]);

}
var staticRenderFns = []

export { render, staticRenderFns }